<script lang="ts">
	// Formating
	import { format } from 'svelte-i18n';
	// Helpers
	import { devices_status } from 'src/stores/device-runtime/status';
	import { devices } from 'src/stores/lists/devices';
	import { deriveRoomName } from 'src/helpers/service_rooms_helpers';
	import { capFirstChar } from 'src/helpers/utilities';
	import { devices_config } from '@devices/index';
	import { sortBy } from 'src/components/Lists/list-helpers';
	// Design system components
	import SelectList from 'src/components/SelectList/SelectList.svelte';
	// Types
	import type { Device } from 'src/types/Device';
	import type { PVSetupTypes } from './pv_setup_helper';
	import { real_id } from 'src/helpers/interface_helpers';

	$: statusSnapshot = $devices_status;
	export let selectedDevices: Device[];
	export let excludedDevices: Device[] = [];
	export let type: PVSetupTypes;
	export let pvCategory: 'grid' | 'solar' = 'grid';

	$: category =
		pvCategory == 'solar' && type == 'BalconyPV' ? /^(power_meter|relay|emeter)$/ : /^(emeter)$/;

	let allItemsRefs: { [key: string | number]: HTMLElement } = {};

	const handleSelection = (dev: Device) => {
		if (selectedDevices.find((d) => d.id == dev.id)) {
			selectedDevices = selectedDevices.filter((d) => d.id != dev.id);
		} else {
			selectedDevices.push(dev);
			selectedDevices = selectedDevices;
		}
	};

	const sortListByPosition = (list: any) => {
		return list.sort((x: any, y: any) => {
			return sortBy(x, y, 'position');
		});
	};

	const filterDevices: any = (
		devices: Device[],
		selectedDevices: Device[],
		excludedDevices: Device[],
	) => {
		let filteredDevicesByRoom = {};
		devices
			.filter(
				(dev) =>
					category.test(dev.category) &&
					devices_config[dev.type]?.isPM &&
					!dev.shared &&
					!(excludedDevices || []).find((d) => d.id == dev.id),
			)
			.forEach((device: Device, _i) => {
				const roomID = device.room_id;
				const deviceData = {
					name: `${device.name}${
						!statusSnapshot?.[real_id(device.id)]?.online
							? `- ${capFirstChar($format('label_offline'))}`
							: ''
					}`,
					id: device.id,
					selected: selectedDevices.find((el) => el.id == device.id) != null,
					roomName: deriveRoomName(roomID),
					roomID: roomID,
					image: device.image ? device.image : undefined,
					backgroundColor: device.backgroundColor ? device.backgroundColor : undefined,
					icon: device.icon ? device.icon : undefined,
				};

				if (filteredDevicesByRoom[roomID]) {
					filteredDevicesByRoom[roomID].cards = [
						...filteredDevicesByRoom[roomID].cards,
						deviceData,
					];
				} else {
					filteredDevicesByRoom[roomID] = {
						cards: [deviceData],
						roomName: deriveRoomName(roomID),
						roomID: roomID,
					};
				}
			});
		return Object.values(filteredDevicesByRoom);
	};

	$: roomsFiltered = (statusSnapshot, sortListByPosition(
		filterDevices(Object.values($devices), selectedDevices, excludedDevices),
	));
</script>

{#key category}
	<SelectList
		title={$format('label_selected', {
			default: 'Selected:',
		})}
		titleHighlight={selectedDevices.length}
		list={roomsFiltered}
		bind:allCardsRefs={allItemsRefs}
		on:click={(e) => {
			handleSelection(e.detail);
		}}
	/>
{/key}
